import { Component, Input, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';

@Component({
    selector: 'feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss'],
    providers: [],
    standalone: false
})

export class FeedbackComponent implements OnInit {
  @Input() dynamicContent: Models.DynamicContent;
  @Input() parent: Models.DynamicContentEntrance;
  @Input() create: any;
  public tableData = null;
  public columns = [{ prop: 'name' }, { prop: 'GroupID' }]
  readonly separatorKeysCodes = [ENTER, COMMA] as const;

  public form: UntypedFormGroup = new UntypedFormGroup({
    type: new UntypedFormControl('', Validators.required),
    answers: new UntypedFormControl([]),
    allowedGroups: new UntypedFormControl([]),
    scaleMin: new UntypedFormControl(0),
    scaleMax: new UntypedFormControl(0),
    scaleStep: new UntypedFormControl(0),
    scaleIcon: new UntypedFormControl('', Validators.required),
    mandatory: new UntypedFormControl(false)
  });

  types = ['singleChoice', 'multipleChoice', 'scale', 'textArea', 'text', 'email'];
  scaleIconType = ['star', 'heart', 'numeric'];
  addOnBlur = true;
  answers = [];
  isMain = false;

  constructor() {
    this.isMain = this.parent instanceof Models.DynamicContentEntrance;
  }

  ngOnInit() {
    this.isMain = this.parent instanceof Models.DynamicContentEntrance;
    this.form.valueChanges.subscribe(res => {
      this.dynamicContent.content = Object.assign(this.dynamicContent.content, res);
    });
    if (this.dynamicContent.title) {
      this.form.patchValue(this.dynamicContent.content);
      this.answers = this.dynamicContent.content.answers;
    }
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.answers.push(value.slice(0, 80));
    }
    event.chipInput!.clear();
    this.form.patchValue({ answers: this.answers });
  }

  remove(answer): void {
    const index = this.answers.indexOf(answer);
    if (index >= 0) {
      this.answers.splice(index, 1);
    }
    this.form.patchValue({ answers: this.answers });
  }

  checkMax(event) {
    if (this.form.controls.scaleIcon.value !== 'numeric' && parseInt(event.target.value, 10) > 10) {
      event.target.value = '10';
    }
  }
}
